import request from './index'
// const baseApi = ""
const baseApi = "/prod-api"
const getHome = (data) => {
  return request(
    {
      url: baseApi + '/cms/type/listForWw',
      method: 'get',
      params: data
    }
  )
}
const getAriticle = (data) => {
  return request(
    {
      url:  baseApi + '/cms/blog/cms/cmsListByTypeLang',
      method: 'get',
      params: data
    }
  )
}
const getResume = () => {
  return request(
    {
      url:  baseApi + '/cms/blog/cms/getResume',
      method: 'get',
    }
  )
}
const getRecruitment = () => {
  return request(
    {
      url:  baseApi + '/system/dict/data/type/sys_gangwei',
      method: 'get',
    }
  )
}
const getAriticleById = (data) => {
  return request(
    {
      url:  baseApi + '/cms/blog/cms/cmsListByIdLang',
      method: 'get',
      params: data
    }
  )
}
const getBanner = () => {
  return request(
    {
      url:  baseApi + '/system/ad/list',
      method: 'get',
    }
  )
}
// 查询分类列表
const listClassification = (query) => {
  return request({
    url:  baseApi + '/cms/snip/list',
    method: 'get',
    params: query
  })
}

// 查询分类详细
const getClassification = (query) => {
  return request({
    url:  baseApi + '/cms/snip/detail',
    method: 'get',
    params: query
  })
}
// 查询联系人信息
const getUs = () => {
  return request({
    url:  baseApi + '/system/us/selectUsList',
    method: 'get'
  })
}
// 提交联系我们
const submitCmsCustomer = (data) => {
  return request({
    url:  baseApi + '/cms/blog/cms/submitCmsCustomer',
    method: 'post',
    data:data
  })
}
// 查询二维码
const selectQrCodeList = (query) => {
  return request({
    url:  baseApi + '/system/us/selectQrCodeList',
    method: 'get',
    params:query
  })
}
// 查询二维码
const selectPartnerList = (query) => {
  return request({
    url:  baseApi + '/system/us/selectPartnerList',
    method: 'get',
    params:query
  })
}

export default {
  getHome, getAriticle,getResume,getRecruitment, getAriticleById, getBanner, listClassification, getClassification, getUs,submitCmsCustomer,selectQrCodeList,selectPartnerList
}



// WEBPACK FOOTER //
// ./src/api/api.js